import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { IoSearch } from 'react-icons/io5';

import ViewImage from 'modules/common/Img/components/ViewImage';
import { formatCurrency, parseNumber } from 'modules/common/utils';

export const CartRowHeader = ({ withPrice, withRemove }) => (
  <div className="flex items-start gap-3 text-sm">
    <div className="grid grid-cols-8 flex-1">
      <div className="flex-1 leading-tight col-span-6 font-semibold">
        Item Ordered
      </div>

      {withPrice && (
        <div className="flex-shrink-0 col-span-2 text-right font-semibold pr-1">
          Price
        </div>
      )}
    </div>

    {withRemove && <div className="w-5" />}
  </div>
);

CartRowHeader.defaultProps = {
  withPrice: true,
  withRemove: true,
};

CartRowHeader.propTypes = {
  withPrice: PropTypes.bool,
  withRemove: PropTypes.bool,
};

function CartRowV2({ value: data, withPrice, isWhiteBg, withImage }) {
  return (
    <div className="flex items-start gap-3 text-sm">
      <div className="grid grid-cols-8 flex-1">
        <div className="leading-tight col-span-6 flex gap-3.5 items-start">
          {withImage ? (
            <div className="w-10 relative">
              <ViewImage
                src={data?.photo_url}
                heightClassName="h-10"
                containerClassName="rounded"
                disableLoader
                enableLightBox
                stopPropagation
                className="bg-white"
                hoverLabel={<IoSearch className="h-5 w-5" />}
              />

              <div className="absolute -top-1.5 -right-1.5">
                <div
                  className={cn(
                    'bg-primary-500 min-w-[20px] leading-none text-center rounded-full p-1 text-xs font-medium text-white'
                  )}
                >
                  {data?.quantity}
                </div>
              </div>
            </div>
          ) : (
            <div className="font-semibold">{data?.quantity}x</div>
          )}

          <div className="space-y-0">
            <div
              className={cn({
                'text-xs': !isWhiteBg,
              })}
            >
              {data?.name || '-'}
            </div>

            <div className="text-gray-400 text-xs">
              <div className="capitalize">{data?.code}</div>
              {data?.addOns?.map((item, key) => (
                <div
                  // eslint-disable-next-line react/no-array-index-key
                  key={key}
                >
                  + {item?.name} ~ {formatCurrency(parseNumber(item?.price))}
                </div>
              ))}
            </div>
          </div>
        </div>

        {withPrice && (
          <div className="flex-shrink-0 col-span-2 text-right leading-tight">
            {formatCurrency(data?.price || 0)}
          </div>
        )}
      </div>
    </div>
  );
}

CartRowV2.defaultProps = {
  value: {},
  withPrice: true,
  isWhiteBg: false,
  withImage: true,
};

CartRowV2.propTypes = {
  value: PropTypes.instanceOf(Object),
  isWhiteBg: PropTypes.bool,
  withImage: PropTypes.bool,
  withPrice: PropTypes.bool,
};

export default CartRowV2;
